<!--
  ~ Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ng-template cdkConnectedOverlay
             cdkConnectedOverlayLockPosition
             [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
             [cdkConnectedOverlayOrigin]="triggerRef"
             [cdkConnectedOverlayOpen]="isOpen"
             [cdkConnectedOverlayPositions]="positions"
             [cdkConnectedOverlayWidth]="fitTriggerWidth() ? triggerRect?.width : null"
             [cdkConnectedOverlayMinWidth]="fitTriggerWidth() ? null : triggerRect?.width"
             (overlayOutsideClick)="handleClose($event)"
             (detach)="close()"
             (positionChange)="onPositionChange()">
  <div class="overlay-content-wrapper"
       [class.visible]="isPositioned"
       [class.ngf-options-fit-trigger-width]="fitTriggerWidth()">
    <ng-content></ng-content>
  </div>
</ng-template>
